import styled from 'styled-components'
import { Application } from '../../config'

const { isNemi } = Application

export default styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  /* Nemi paints these in its light purple, the other brands in their primary colour, as the app does. */
  color: ${ ({ theme }) => isNemi ? theme.colors.accent : theme.colors.primary };

  .label {
    padding: 4px 10px;
    border: none;
    border-radius: 13px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    background-color: ${ ({ theme }) => theme.colors.white };
    color: inherit;
    font-family: ${ ({ theme }) => theme.fontFamily };
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
  }

  /* Same footprint as the map's Google controls (controlSize 26). */
  .round {
    width: 26px;
    height: 26px;
    padding: 3px;
    border: 2px solid transparent;
    border-radius: 50%;
    background-color: ${ ({ theme }) => theme.colors.white };
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
    color: inherit;
    cursor: pointer;

    &.open {
      border-color: currentColor;
    }

    svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
`
